module.exports = __webpack_public_path__ + "img/gold_framed_symbols.56d322ce.png";